module.exports = __webpack_public_path__ + "static/media/battles-leaderboard.d6ccd412.png";